import React from 'react'
import styled from 'styled-components'

export default function () {
    return (
        <Wrapper>
            <Flex>
                <Heading>Totato</Heading>
                <Heading>Works</Heading>
            </Flex>
            <h2>
                Please login to use
            </h2>
        </Wrapper>
    )
}

const Wrapper = styled.div({
    margin: 'auto',
    padding: '2em 0',
    textAlign: 'center'
})
const Heading = styled.h1``
const Flex = styled.div({
    display: 'flex',
    fontWeight: 600,
    justifyContent: 'center',
})


// WEBPACK FOOTER //
// ./src/components/MessageLogin.js